export const GET_CONFIRMATION_CHECKS = "GET_CONFIRMATION_CHECKS";
export const GET_CONFIRMATION_CHECKS_SUCCESS =
  "GET_CONFIRMATION_CHECKS_SUCCESS";
export const GET_CONFIRMATION_CHECKS_ERROR = "GET_CONFIRMATION_CHECKS_ERROR";

export const PUT_CONFIRMATION_CHECKS = "PUT_CONFIRMATION_CHECKS";
export const PUT_CONFIRMATION_CHECKS_SUCCESS =
  "PUT_CONFIRMATION_CHECKS_SUCCESS";
export const PUT_CONFIRMATION_CHECKS_ERROR = "PUT_CONFIRMATION_CHECKS_ERROR";
